import React, { useEffect } from 'react'
import { moduleContext } from 'react-contextual'
import { useDispatch, useSelector } from 'react-redux'
import { walletApiEvents, walletApiSelectors } from '../../../../../../modules/api/wallet'

interface ContactBalanceProviderProps {
  accountId: string
  customerId: string
  accountType: string
}

const ContactBalanceProvider = moduleContext()(
  ({
    context,
    children,
    accountId,
    customerId,
    accountType,
  }: ContactBalanceProviderProps & { context: any; children: React.ReactNode }) => {
    const dispatch = useDispatch()

    // Fetch party balances
    useEffect(() => {
      dispatch(walletApiEvents.balance_request({ partyId: customerId }))
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId])

    const store = {
      balance: useSelector(state => walletApiSelectors.getBalance(state)(customerId, accountId, accountType)),
    }

    return <context.Provider value={store}>{children}</context.Provider>
  },
)

export default ContactBalanceProvider
